<div class="spinner-container">
  <mat-spinner [diameter]="50" [strokeWidth]="5" color="primary"></mat-spinner>
</div>

